
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, DollarSign, Package, TrendingUp } from 'lucide-react';

interface DashboardStatsProps {
  totalBookings: number;
  totalRevenue: number;
  totalCommission: number;
  netPayout: number;
  onStatClick?: (statType: string) => void;
}

const DashboardStats = ({
  totalBookings,
  totalRevenue,
  totalCommission,
  netPayout,
  onStatClick
}: DashboardStatsProps) => {
  const stats = [
    {
      id: 'bookings',
      label: 'إجمالي الحجوزات',
      value: totalBookings,
      icon: Package,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 'revenue',
      label: 'إجمالي الإيرادات',
      value: `$${totalRevenue.toFixed(2)}`,
      icon: DollarSign,
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 'commission',
      label: 'إجمالي العمولة',
      value: `$${totalCommission.toFixed(2)}`,
      icon: TrendingUp,
      color: 'bg-yellow-100 text-yellow-600'
    },
    {
      id: 'payout',
      label: 'صافي الدفع',
      value: `$${netPayout.toFixed(2)}`,
      icon: Calendar,
      color: 'bg-purple-100 text-purple-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card 
            key={stat.id} 
            className={`${onStatClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
            onClick={() => onStatClick?.(stat.id)}
          >
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className={`p-2 rounded-lg ${stat.color}`}>
                  <Icon className="h-6 w-6" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.label}</p>
                  <p className="text-2xl font-bold">{stat.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default DashboardStats;
